export default __webpack_public_path__ + "static/media/defaultImg.a200101f.png";